<template>
  <!-- 油品发票 -->
  <div class="home-page-container">
    <div class="oil-invoice-wrapper">
      <el-row :gutter="20">
        <!-- 油品发票金额 -->
        <el-col :span="8" class="box" style="padding-right: 40px;">
          <div class="tabs">
            <div :class="{ 'active': !isHistory }" @click="onChangeTab(false)">近期</div>
            <i class="line"></i>
            <div :class="{ 'active': isHistory }" @click="onChangeTab(true)">历史</div>
          </div>
          <div class="box2">
            <div class="invoice-balance balance2" v-if="showFlag">
              <el-tooltip class="item" effect="light" :content="`当前商户${isHistory ? '历史' : '近期'}账单待开给我司的发票金额`" placement="right">
                <div class="title">待开发票金额 <i class="el-icon-question"></i></div>
              </el-tooltip>
              <div class="balance">
                <span class="flag">¥</span>
                <span>{{invoicingAmount || '0.00'}}</span>
              </div>
            </div>
            <div class="invoice-balance balance2">
              <el-tooltip class="item" effect="light" :content="`当前商户${isHistory ? '历史' : '近期'}账单给我司已开票金额+待开票金额合计`" placement="top-start">
                <div class="title">应开发票总金额 <i class="el-icon-question"></i></div>
              </el-tooltip>
              <div class="balance">
                <span class="flag">¥</span>
                <span>{{invoiceAmount || '0.00'}}</span>
              </div>
            </div>
          </div>
          <div class="box2">
            <div class="invoice-balance balance2" v-if="showFlag">
              <el-tooltip class="item" effect="light" :content="`当前商户${isHistory ? '历史' : '近期'}账单已开给我司的发票金额`" placement="right">
                <div class="title">已开发票金额 <i class="el-icon-question"></i></div>
              </el-tooltip>
              <div class="balance">
                <span class="flag">¥</span>
                <span>{{invoicedAmount || '0.00'}}</span>
              </div>
            </div>
          </div>
        </el-col>
        <!-- 发票抬头信息 -->
        <el-col :span="16">
          <div class="invoice-info">
            <div class="title">发票抬头信息</div>
              <el-row>
                <el-col :span="9">
                  <div class="info-item">
                    <span class="label">开票抬头：</span>
                    <span class="info">{{invoiceInfo.companyName}}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">纳税人识别号：</span>
                    <span class="info">{{invoiceInfo.taxpayerCode}}</span>
                  </div>
                </el-col>
                <el-col :span="15">
                  <div class="info-item">
                    <span class="label">开户行和账号：</span>
                    <span class="info">{{invoiceInfo.bankName}}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">联系电话和地址：</span>
                    <span class="info">{{invoiceInfo.addressPhone}}</span>
                  </div>
                </el-col>
              </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-card shadow="never" style="margin: 20px 0">
       <mer-search :searchConfig="formConfig" :searchBar="searchBar"
        @search="interSearch"
        @reset="reset(initQuery)"
        @changeTime="(value,model)=>changeTime(value,'searchBar', `startTime`, `endTime`)"
        @changeOption="changeOption"
        :loading="tableLoading"
        :isLayout="true">
        <template slot="handler">
          <!-- <el-button size="mini" @click="download" icon="el-icon-download">导出</el-button> -->
          <download-button :downloadApi="downloadApi" :queryParams="{ ...downloadParams }"></download-button>
          <!-- <el-button style="margin-left:10px" size="mini" @click="moreBill">查看21年及之前的账单</el-button> -->
        </template>
      </mer-search>
    </el-card>
    <el-card shadow="never">
      <!-- <div class="g-flex-start summary_info" v-if="singleGasOrMerchant">
        <div>待开发票总金额(元)： <span>{{summaryInfo.invoicingAmount}}</span></div>
        <div>应开发票总金额(元)： <span>{{summaryInfo.invoiceAmount}}</span></div>
        <div>已开发票总金额(元)： <span>{{summaryInfo.invoicedAmount}}</span></div>
      </div> -->
      <div>
        <el-button type="warning" size="mini" @click="selectPage">全选本页</el-button>
        <!-- <el-button type="warning" size="mini" class="button_space">全选所有</el-button> -->
        <el-button type="primary" size="mini" class="button_space" @click="batchWriteOff">批量核销</el-button>
        <el-button type="primary" size="mini" @click="routeToRecord">核销记录</el-button>
        <span v-if="pendingConfirmCount > 0" class="pending_tip">
          <i class="el-icon-warning"></i>
          温馨提示：现有 <span class="pending_count">{{ pendingConfirmCount }}</span> 笔账单由平台运营代发起核销申请，请于3个自然日内完成确认，超时将自动确认。
          <a class="go_confirm" @click="openPendingConfirmDialog">去确认>></a>
        </span>
      </div>
      <!-- table 表格 -->
      <el-tabs v-model="activeNameOfTable" type="card" @tab-click="handleClick" style="margin-top: 20px;">
        <el-tab-pane label="近期账单" name="now">
          <span slot="label">
            近期账单
            <el-tooltip effect="light" content="2023年11月1日及之后账单">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
        </el-tab-pane>
        <el-tab-pane label="历史账单" name="history">
          <span slot="label">
            历史账单
            <el-tooltip effect="light" content="2023年11月1日之前账单">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
        </el-tab-pane>
      </el-tabs>
      <mer-table :loading="tableLoading"
        ref="multipleTable"
        :tableConfig="tableConfig"
        :tableData="tableData"
        :pagination="pagination"
        :row-key="row => row.id"
        @selection-change="handleSelectionChange"
        @SizeChange="handleSizeChange"
        @PageChange="pageChange">
        <template slot="table">
          <el-table-column
            :reserve-selection="true"
            :selectable="selectable"
            type="selection"
            width="55">
          </el-table-column>
        </template>
        <template slot="handler" slot-scope="{row}">
          <div class="btn_group">
            <el-button size="mini" type="text" @click="writeOffRow(row)" v-if="[10, 20].includes(row.status) && row.oilSpuName">核销账单</el-button>
            <el-button size="mini" type="text" @click="billAppeal(row)" v-if="[10].includes(row.status)">账单申诉</el-button>
            <el-button size="mini" type="text" @click="showDetail(row)">账单明细</el-button>
          </div>
        </template>
      </mer-table>
    </el-card>
    <!-- 账单明细 -->
    <invoice-detail v-if="Object.keys(invoiceDetailParams).length" :singleGas="singleGasOrMerchant" :data="invoiceDetailParams" @close="invoiceDetailParams={}" />
    <!-- 账单核销 -->
    <el-dialog
      title="发票信息填写"
      :visible.sync="writeOffVisible"
    >
      <el-form
        ref="writeOffForm"
        :model="writeOffForm"
        label-width="130px"
        :rules="writeOffRules"
      >
        <el-form-item label="共计账单金额：">
          {{ amount }}
        </el-form-item>
        <el-form-item label="油品：">
          <span>{{ writeOffForm.invoiceInfoDtos[0].spuName }}</span>
        </el-form-item>
        <el-form-item label="发票代码：" prop="invoiceInfoDtos[0].invoiceCode">
          <el-input class="input_width" size="small" v-model="writeOffForm.invoiceInfoDtos[0].invoiceCode" placeholder="请输入发票代码"></el-input>
        </el-form-item>
        <el-form-item label="发票号码：" prop="invoiceInfoDtos[0].invoiceNo">
          <el-input class="input_width" size="small" v-model="writeOffForm.invoiceInfoDtos[0].invoiceNo" placeholder="请输入发票号码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button @click="handleWriteOffHide">取 消</el-button>
        <el-button type="primary" @click="writeOffSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 账单申诉 -->
    <el-dialog
      title="申诉"
      :visible.sync="appealVisible"
    >
      <el-form
        ref="appealForm"
        :model="appealForm"
        label-width="130px"
        :rules="appealRules"
      >
        <el-form-item label="申诉原因：" prop="remark">
          <el-select v-model="appealForm.remark" placeholder="请选择">
            <el-option label="账单金额不准确" value="账单金额不准确"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="invoicedAmount" v-if="appealForm.remark === '账单金额不准确'">
          <el-input
            placeholder="请输入正确的应开发票金额"
            v-model="appealForm.invoicedAmount" />
        </el-form-item>
        <el-form-item label="" prop="reason">
          <el-input
            v-model="appealForm.reason"
            placeholder="请输入200字以内的申诉原因"
            type="textarea"
            :maxlength="200"
            :rows="4" />
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button @click="handleAppearHide">取 消</el-button>
        <el-button type="primary" @click="appearSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 待确认核销列表 -->
    <pending-confirm
      ref="pendingConfirmRef"
      :visible.sync="pendingConfirmVisible"
      @confirmed="getPendingConfirmCount"
    />
  </div>
</template>
<script>
import listPage from '@/mixins/listPage'
import queryMix from '@/views/finance/mixins/query';
import { getOilInvoiceInfoApi, downloadOilInvoiceBillApi, exportCompanyOilInvoiceDetail, getSummaryInfo, getEnum, queryInvoiceNew, queryInvoiceHistory, gasNewSummaryData, batchVerificationBills, useBillAppeal, pendingConfirmRecords } from '@/api/finance'
import InvoiceDetail from './components/oilsInvoice/detail'
import PendingConfirm from './components/oilsInvoice/pendingConfirm'
import moment from 'moment'
import { mapState } from 'vuex'

// 查询表单配置
let formConfig = [
  { label: '油站', type: 'select', modelName: 'gasId', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'gasName', selectValue: 'gasId' },
  { label: '签约主体', type: 'select', modelName: 'signBody', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'value', selectValue: 'label' },
  { label: '日期', type: 'date', modelName: 'invoiceTime', model: [], dateType: 'daterange', format: 'yyyy-MM-dd', pickerOptions:{}, clearable:false},
  { label: '油品', type: 'select', modelName: 'oilSpu', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'value', selectValue: 'label' },
  // { label: '提交结果', type: 'select', modelName: 'verificationStatus', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'value', selectValue: 'label' }
]
// 表格参数配置
let tableConfig = [
  { label: '结算单ID', prop: 'id' },
  { label: '账单日期', prop: 'billDay' },
  { label: '油站', prop: 'gasName' },
  { label: '油品', prop: 'oilSpuName' },
  { label: '商户应开发票总金额(元)', prop: 'invoiceAmount' },
  { label: '签约主体', prop: 'signBodyName' },
  { label: '账单更新时间', prop: 'updateTime' },
  { label: '核销状态', prop: 'statusStr' },
  // { label: '提交结果', prop: 'verificationStatusStr' },
  { label: '操作', slot: 'handler', fixed: 'right', width: '150' }
]

// 单油站、商户表格参数
let tableConfigNew = [
  { label: '结算单ID', prop: 'id' },
  { label: '账单日期', prop: 'billDay' },
  { label: '油站', prop: 'gasName' },
  { label: '油品', prop: 'oilSpuName' },
  { label: '商户待开发票总金额(元)', prop: 'invoicingAmount' },
  { label: '商户应开发票总金额(元)', prop: 'invoiceAmount' },
  { label: '商户已开发票总金额(元)', prop: 'invoicedAmount' },
  { label: '签约主体', prop: 'signBodyName' },
  { label: '账单更新时间', prop: 'updateTime' },
  { label: '核销状态', prop: 'statusStr' },
  // { label: '提交结果', prop: 'verificationStatusStr' },
  { label: '操作', slot: 'handler', fixed: 'right', width: '150' }
]

export default {
  name: 'invoice_oilsInvoice',
  mixins:[ listPage, queryMix ],
  components:{
    InvoiceDetail,
    PendingConfirm
  },
  data(){
    const validateCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入发票代码'))
      }
      // if (String(value).length !== 12) {
      //   return callback(new Error('发票代码为12位数字'))
      // }
      callback()
    }
    const validateNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入发票号码'))
      }
      // if (String(value).length !== 8) {
      //   return callback(new Error('发票代码为8位数字'))
      // }
      callback()
    }
    return{
      downloadApi: downloadOilInvoiceBillApi,
      invoiceTime: [],
      formConfig,
      tableConfig,
      invoiceInfo:{
        companyName: '',
        bankName: '',
        taxpayerCode: '',
        addressPhone:''
      },
      allQueryProps:{},
      // invoiceBalacne: '0.00',
      invoiceAmount: '0.00',
      invoicedAmount: '0.00',
      invoicingAmount: '0.00',
      invoiceDetailParams:{},
      summaryInfo: {},
      activeNameOfTable: 'now',
      invoiceStatusOption: [], // 核销状态
      spuTypeOptionList: [], // 油品
      writeOffVisible: false, // 批量核销显示
      writeOffForm: { // 批量核销
        invoiceInfoDtos: [{
          invoiceNo: '',
          invoiceCode: '',
          spuName: '',
          spuId: ''
        }],
        billIds: [],
        verificationType: 1
      },
      writeOffRules: {
        'invoiceInfoDtos[0].invoiceCode': [
          { required: true, validator: validateCode, trigger: ['blur', 'change'] },
          // { type: 'number', message: '只能输入数字', trigger: ['blur', 'change'] }
        ],
        'invoiceInfoDtos[0].invoiceNo': [
          { required: true, validator: validateNo, trigger: ['blur', 'change'] },
          // { type: 'number', message: '只能输入数字', trigger: ['blur', 'change'] }
        ]
      },
      amount: '', // 共计账单金额
      appealVisible: false, // 账单申诉显示
      appealForm: { // 账单申诉
        billId: '',
        invoicedAmount: '',
        remark: '',
        reason: ''
      },
      appealRules: {
        remark: [
          { required: true, message: '请选择申诉原因', trigger: 'change' }
        ],
        invoicedAmount: [
          { required: true, message: '请输入正确的应开发票金额', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '请输入申诉原因', trigger: 'blur' }
        ]
      },
      selection: [], // 选中的账单id
      selectBillFromTable: false, // 是否为table操作中点击的核销账单
      isHistory: false, // 是否为历史订单
      showFlag: false,
      // 待确认核销
      pendingConfirmCount: 0,
      pendingConfirmVisible: false
    }
  },
  async created(){
    this.searchBar.invoiceFlag = 1
    await this.initEnum()
    // 判断是否为单油站或商户,展示不同信息
    if (this.singleGasOrMerchant) {
      this.downloadApi = exportCompanyOilInvoiceDetail
      this.tableConfig = tableConfigNew
      // const _this = this
      // formConfig[2].pickerOptions = {
      //   disabledDate(time) {
      //     if (_this.selectDate) {
      //       // 限制时间选择范围366天
      //       const one = 365 * 24 * 3600 * 1000;
      //       const minTime = _this.selectDate - one;
      //       const maxTime = _this.selectDate + one;
      //       if (_this.singleGasOrMerchant) {
      //         // 2022/06为分界点，只能选择之前或之后的日期
      //         if (_this.selectDate <= new Date('2022 06').valueOf() && (time.getTime() < new Date('2019 12').valueOf() || time.getTime() > new Date('2022 06').valueOf())) {
      //           _this.$_listApi = getCompanyInvoice
      //           return true
      //         }
      //         if (_this.selectDate > new Date('2022 06').valueOf() && time.getTime() < new Date('2022 07').valueOf()) {
      //           _this.$_listApi = companyListOilInvoiceByPage
      //           return true
      //         }
      //         return false
      //       } else {
      //         return time.getTime() < minTime  || time.getTime() > maxTime
      //       }
      //     } else if (_this.singleGasOrMerchant) {
      //       return time.getTime() < new Date('2019 12').valueOf()
      //     }
      //   },
      //   onPick: ({ maxDate, minDate }) => {
      //     _this.selectDate = minDate.getTime()
      //     if (maxDate) {
      //       _this.selectDate = ''
      //     }
      //   },
      // }
    }
    const _this = this
    formConfig[2].pickerOptions = {
      disabledDate(time) {
        if (_this.selectDate) {
          // 限制时间选择范围366天
          const one = 365 * 24 * 3600 * 1000;
          const minTime = _this.selectDate - one;
          const maxTime = _this.selectDate + one;
          return time.getTime() < minTime  || time.getTime() > maxTime
        }
      },
      onPick: ({ maxDate, minDate }) => {
        _this.selectDate = minDate.getTime()
        if (maxDate) {
          _this.selectDate = ''
        }
      },
    }
    // this.formConfig = formConfig.filter(item => {
    //     return this.singleGasOrMerchant ? item.modelName !== 'gasId' : item.modelName !== 'oilSpu'
    // })

    this.$track.pageViewEvent('油品发票管理', '1621476239')
    this.initPage()
    this.initInvoiceInfo() //解决二次刷新，数据丢失
    this.getSummaryInfo()
    this.getPendingConfirmCount()
  },
  activated(){
    this.initInvoiceInfo()
    this.getPendingConfirmCount()
  },
  computed: {
     ...mapState('user', {
      userInfo: state => state.userInfo
    }),
    // 是否为单油站或商户
    singleGasOrMerchant () {
      return this.userInfo.company || this.userInfo.singleGas
    }
  },
  methods:{
    moreBill () {
      this.$router.push({ path: '/invoice/oilsInvoiceMore'})
    },
    initPage () {
      this.getQueryProps()
      this.initQuery()
      this.initList(queryInvoiceNew, false)
    },
    // 设置默认查询条件，默认时间间隔3个月
    initQuery () {
      this.invoiceTime = []
      this.initMonth()
      // this.searchBar.oilSpu = this.spuTypeOptionList[0].label // 去掉油品默认值
      // const {invoiceTime,pickerOptions} = this
      // const initObj = { invoiceTime:[invoiceTime,pickerOptions] }
      // this.setSearchConfig(initObj)
    },
    initMonth(){
      let start = moment().month(moment().month() - 3).date(moment().date() - 1).format('YYYY-MM-DD HH:mm:ss')
      const end = moment().date(moment().date() - 1).format('YYYY-MM-DD HH:mm:ss')
      const start_year = moment(start).year()
      const end_year = moment(end).year()
      // 不允许初始值跨年，如果年份不同，将开始时间设置为1月
      if(start_year !== end_year){
        start = moment().month(0).startOf('month').format('YYYY-MM-DD HH:mm:ss')
      }
      this.invoiceTime = [start,end]
      this.searchBar[`startTime`] = moment(start).format('YYYY-MM-DD')
      this.searchBar[`endTime`] = moment(end).format('YYYY-MM-DD')

      // 回显默认时间
      let item = this.formConfig.find(item => item.modelName === 'invoiceTime')
      item.model = [moment(start).format('YYYY-MM-DD'), moment(end).format('YYYY-MM-DD')]
    },
    getQueryProps(){
      // 获取查询条件：油站
      this.getAllGasStations()
    },
    initInvoiceInfo(){
      this.getInvoiceBalanceNow()
      this.getInvoiceInfo()
    },
    onChangeTab(isHistory) {
      this.isHistory = isHistory
      this.getInvoiceBalanceNow(isHistory)
    },
    // 查询近期金额汇总
    async getInvoiceBalanceNow (isHistory = false) {
      try{
        const { code,result = {} } = await gasNewSummaryData({ history: isHistory, invoiceFlag: 1 })
        if(code !== 200) return
        this.invoiceAmount = result.invoiceAmount
        this.invoicedAmount = result.amount
        this.invoicingAmount = result.invoicingAmount
        this.showFlag = result.showFlag
      } catch(err){
        console.log(err)
      }
    },
    // 获取油品发票信息
    async getInvoiceInfo () {
      try{
        const { code,result = {} } = await getOilInvoiceInfoApi()
        if(code !== 200) return
        this.invoiceInfo = result || {}
      }catch(err){
        console.log(err)
      }
    },
    //导出
    download () {
      this.downloadFile(downloadOilInvoiceBillApi,'预存款')
    },
    // 发票账单明细
    showDetail(row){
      const { gasId, billDay, oilNo, invoiceFlag, oilSpu } = row
      this.invoiceDetailParams = { gasId, billMonth: billDay, oilNo, invoiceFlag, spuId: billDay > '2022-06' ? oilSpu : null }
    },
    async getSummaryInfo () {
      const { code, result } = await getSummaryInfo(this.searchBar)
      if (code !== 200) return
      this.summaryInfo = result
    },
    // 查询方法增加一层装饰器
    interSearch () {
      this.getSummaryInfo()
      this.search()
      this.$refs.multipleTable.$children[0].clearSelection()
    },
    handleClick (tab) {
      this.initList(tab.name === 'now' ? queryInvoiceNew : queryInvoiceHistory, false)
      this.$refs.multipleTable.$children[0].clearSelection()
    },
    async initEnum () {
      const { code, result } = await getEnum()
      if (code !== 200) return
      const { invoiceStatusOption, signBodyOption, spuTypeOption, 
        // verificationStatusOption 
      } = result
      formConfig.find(item => item.modelName === 'signBody').selectOptions = signBodyOption
      formConfig.find(item => item.modelName === 'oilSpu').selectOptions = spuTypeOption
      // formConfig.find(item => item.modelName === 'verificationStatus').selectOptions = verificationStatusOption || []
      this.spuTypeOptionList = spuTypeOption
      this.invoiceStatusOption = invoiceStatusOption
    },
    writeOffSubmit () {
      this.$refs.writeOffForm.validate(async valid => {
        this.writeOffForm.billIds = this.selection.join(',')
        if (!valid) return
        const { code } = await batchVerificationBills(this.writeOffForm)
        if (code !== 200) return
        this.$message.success('发票核销信息已提交，等待审核人员核实')
        this.handleWriteOffHide()
        this.interSearch()
        this.$refs.multipleTable.$children[0].clearSelection()
      })
    },
    batchWriteOff () {
      if (!this.selection.length) return this.$message.warning('请选择账单')
      this.writeOffVisible = true
    },
    changeOption (val, model) {
      if (model === 'oilSpu') {
        this.writeOffForm.invoiceInfoDtos[0].spuName = val ? this.spuTypeOptionList.find(item => item.label === val).value : ''
        this.writeOffForm.invoiceInfoDtos[0].spuId = val ? this.spuTypeOptionList.find(item => item.label === val).label : ''
      }
    },
    writeOffRow ({ id, invoiceAmount, oilSpu, oilSpuName }) {
      this.selectBillFromTable = true
      this.selection = [ id ]
      this.writeOffForm.invoiceInfoDtos[0].spuName = oilSpuName
      this.writeOffForm.invoiceInfoDtos[0].spuId = oilSpu
      this.amount = invoiceAmount
      this.writeOffVisible = true
    },
    billAppeal ({ id }) {
      this.appealForm.billId = id
      this.appealVisible = true
    },
    appearSubmit () {
      this.$refs.appealForm.validate(async valid => {
        if (!valid) return
        const params = {
          billId: this.appealForm.billId,
          invoicedAmount: this.appealForm.invoicedAmount,
          remark: this.appealForm.remark + '-' + this.appealForm.reason
        }
        const { code } = await useBillAppeal(params)
        if (code !== 200) return
        this.$message.success('申诉成功')
        this.handleAppearHide()
        this.interSearch()
      })
    },
    handleAppearHide () {
      this.appealVisible = false
      this.$refs.appealForm.resetFields()
    },
    routeToRecord () {
      this.$router.push({ path: '/invoice/oilsInvoiceRecord' })
    },
    // 控制表格行是否可选
    selectable (row) {
      return (row.oilSpuName && row.oilSpu) && [10, 20].includes(row.status)
    },
    // 勾选table复选框
    handleSelectionChange (selection) {
      this.selection = selection.map(item => item.id)
      this.amount = selection.reduce((total, item) => {
        return total + parseFloat(item.invoiceAmount.split(',').join(''))
      }, 0)
      this.writeOffForm.invoiceInfoDtos[0].spuName = selection[0]?.oilSpuName || ''
      this.writeOffForm.invoiceInfoDtos[0].spuId = selection[0]?.oilSpu || ''
    },
    // 全选本页
    selectPage () {
      this.$refs.multipleTable.$children[0].toggleAllSelection()
    },
    // 隐藏账单核销
    handleWriteOffHide () {
      this.writeOffVisible = false
      this.$refs.writeOffForm.resetFields()
      if (this.selectBillFromTable) {
        this.selection = []
        this.selectBillFromTable = false
      }
    },
    // 打开待确认核销列表弹窗
    openPendingConfirmDialog () {
      this.pendingConfirmVisible = true
    },
    // 查询待确认核销笔数
    async getPendingConfirmCount () {
      const { code, result = [], totalRow } = await pendingConfirmRecords({
        pageIndex: 1,
        pageSize: 1
      })
      if (code !== 200) return
      this.pendingConfirmCount = parseInt(totalRow === undefined ? result.length : totalRow) || 0
    },
  }
}
</script>
<style lang="less" scoped>
.home-page-container{
  margin-top: 20px;
  .summary_info {
    font-size: 14px;
    margin-bottom: 10px;
    div {
      margin-right: 30px;
      color: #606266;
      span {
        color: #4B7EFE;
      }
    }
  }
}
.oil-invoice-wrapper{
  margin-bottom: 20px;
  box-sizing: border-box;
  /deep/ .box {
    display: flex;
    justify-content: space-around;
    background: #fff;
    height: 138px;
    position: relative;
  }
  .tabs {
    position: absolute;
    top: 5px;
    right: 5px;
    display: flex;
    font-size: 12px;
    color: #A6A6A6;
    align-items: center;
    .line {
      width: 1.5px;
      height: 12px;
      background: #A6A6A6;
      margin: 0 2px;
    }
    .active {
      color: #4B7EFE;
    }
    div {
      cursor: pointer;
    }
  }
  .invoice-balance{
    background: #FFF;
    height: 138px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title{
      font-size: 14px;
      color: #A6A6A6;
      margin-bottom: 17px;
    }
    .balance{
      font-size: 20px;
      color: #222222;
      .flag{
        padding-right: 5px;
        font-size: 10px;
      }
    }
  }
  .balance2 {
    height: 64px;
    .title {
      margin-bottom: 10px;
      font-size: 12px;
    }
    .balance{
      font-size: 18px;
    }
  }
  .toggle_time {
    font-size: 12px;
    text-align: right;
    padding-top: 10px;
    color: #A6A6A6;
    cursor: pointer;
    .divider {
      border-left: 1px solid #A6A6A6;
      margin-left: 3px;
      padding-left: 3px;
    }
    .active {
      color: #4B7EFE;
    }
  }
  .invoice-info{
    background: #FFF;
    height: 138px;
    padding: 24px 28px;
    font-size: 12px;
    .title{
      border-left: 3px solid #4B7EFE;
      padding-left: 5px;
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 25px;
    }
    .info-item{
      margin-bottom: 15px;
      display: flex;
      .label{
        color: #A6A6A6;
        white-space: nowrap;
      }
      .info{
        color: #222222;
        word-break: break-all;
      }
    }
  }
}
.button_space {
  margin-left: 10px;
}

.input_width {
  width: 300px;
}
.btn_group {
  display: flex;
  justify-content: space-around;
}
.pending_tip {
  display: inline-block;
  margin-left: 12px;
  padding: 6px 12px;
  background: #FFF8E6;
  border: 1px solid #FFE5A1;
  border-radius: 4px;
  font-size: 12px;
  color: #606266;
  .el-icon-warning {
    color: #E6A23C;
    margin-right: 6px;
  }
  .pending_count {
    color: #E6A23C;
    font-weight: bold;
    padding: 0 2px;
  }
  .go_confirm {
    color: #4B7EFE;
    cursor: pointer;
    margin-left: 4px;
  }
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
